module.exports = __webpack_public_path__ + "img/settings_en.b677c846.png";